"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
/* eslint-disable camelcase */
const Proposal_1 = __importDefault(require("@becrop/components/Modules/Common/Models/Proposal"));
const axios_1 = __importDefault(require("axios"));
class ProposalsController {
    constructor(obj) {
        this.rawInitialProposals = obj.rawInitialProposals || [];
        this.rawProposals = obj.rawProposals || [];
        this.currentProposals = obj.currentProposals || [];
        this.currentPageProposals = obj.currentPageProposals || {
            numPage: -1,
            proposals: []
        };
        this.paginatedProposals = obj.paginatedProposals || [];
        this.proposal = obj.proposal || new Proposal_1.default({});
        this.fetchedDetails = obj.fetchedDetails || [];
        this.fetchedPagedProposals = obj.fetchedPagedProposals || [];
        this.filteredProposals = obj.filteredProposals || [];
        this.itemsPerPageClient = obj.itemsPerPageClient || 20;
        this.itemsPerPageServer = obj.itemsPerPageServer || 50;
        this.currentPage = obj.currentPage || 1;
        this.totalItems = obj.totalItems || 0;
        this.keyToSearch = obj.keyToSearch || '';
        this.isLoading = false;
        this.orderDirection = 0;
        this.orderCriteria = '';
    }
    get allProposals() {
        return this.rawProposals;
    }
    get numPages() {
        return Math.ceil(this.totalItems / this.itemsPerPageClient);
    }
    get clientPagesByServerCall() {
        return Math.ceil(this.itemsPerPageServer / this.itemsPerPageClient);
    }
    get isAllDownload() {
        const numAllDownloaded = this.fetchedPagedProposals.reduce((a, b) => {
            return a + b.proposals.length;
        }, 0);
        if (numAllDownloaded === this.totalItems)
            return true;
        return false;
    }
    get currentProposalItems() {
        if (this.totalItems > 0) {
            return this.currentPageProposals.proposals;
        }
        else {
            return [];
        }
    }
    initializeProposals(raw_initial_proposals) {
        this.currentPageProposals.numPage = raw_initial_proposals.current_page;
        this.currentPageProposals.proposals = raw_initial_proposals.data;
        this.rawProposals = raw_initial_proposals.data;
        const clientServerFactor = this.itemsPerPageServer / this.itemsPerPageClient;
        const parseServerPage = Math.ceil(1 / clientServerFactor);
        const initialClientPage = (parseServerPage - 1) * clientServerFactor + 1;
        const newPagedProposals = [];
        this.rawProposals.forEach((rawP, i) => {
            const myClientPage = initialClientPage + Math.floor(i / this.itemsPerPageClient);
            const ix = Math.floor(i / this.itemsPerPageClient);
            if (newPagedProposals.findIndex((page) => page.numPage === myClientPage) !== -1) {
                newPagedProposals[ix].proposals.push(rawP);
            }
            else {
                const propInit = [];
                propInit.push(rawP);
                newPagedProposals[ix] = {
                    numPage: myClientPage,
                    proposals: propInit,
                };
            }
        });
        this.fetchedPagedProposals = [
            ...this.fetchedPagedProposals,
            ...newPagedProposals,
        ];
        this.currentPageProposals = newPagedProposals[0];
        this.totalItems = raw_initial_proposals.total;
    }
    updateSortableProposals(c, d) {
        function fixNullsValue(val) {
            let temp = val;
            if (!val)
                temp = '---';
            return temp;
        }
        function getMyKey(criteria) {
            if (criteria === 'name')
                return 'name';
            if (criteria === 'accepted_at')
                return 'accepted_at';
            if (criteria === 'deliverables')
                return 'deliverables';
            if (criteria === 'status')
                return 'status';
            return 'name';
        }
        const keyToSort = getMyKey(c);
        const allDownloadedProposals = [];
        this.fetchedPagedProposals.forEach((pag) => {
            pag.proposals.forEach((prop) => {
                allDownloadedProposals.push(prop);
            });
        });
        if (d === -1 || d === 1) {
            allDownloadedProposals.sort((a, b) => {
                if (keyToSort == 'name') {
                    if (d === -1) {
                        return a.name > b.name ? -1 : 1;
                    }
                    else {
                        return a.name < b.name ? -1 : 1;
                    }
                }
                else if (keyToSort == 'accepted_at') {
                    if (d === -1) {
                        return a.accepted_at > b.accepted_at ? -1 : 1;
                    }
                    else {
                        return a.accepted_at < b.accepted_at ? -1 : 1;
                    }
                }
                else if (keyToSort == 'deliverables') {
                    if (d === -1) {
                        return a.deliverables > b.deliverables ? -1 : 1;
                    }
                    else {
                        return a.deliverables < b.deliverables ? -1 : 1;
                    }
                }
                else {
                    if (d === -1) {
                        return a.status_number > b.status_number ? -1 : 1;
                    }
                    else {
                        return a.status_number < b.status_number ? -1 : 1;
                    }
                }
            });
        }
        this.fetchedPagedProposals.forEach((pag, i) => {
            pag.proposals = [];
            let initialIx = i * this.itemsPerPageClient;
            let finalIx = (i + 1) * this.itemsPerPageClient;
            pag.proposals = allDownloadedProposals.slice(initialIx, finalIx);
        });
        this.loadPage(1);
    }
    async loadPage(n) {
        if (this.fetchedPagedProposals) {
            if (this.fetchedPagedProposals.find((p) => p.numPage === n)) {
                this.currentPageProposals = this.fetchedPagedProposals[n - 1];
            }
            else {
                await this.loadPageForced(n);
            }
        }
        this.currentPage = n;
    }
    async clearAllCachedProposals() {
        this.fetchedPagedProposals = [];
        this.fetchedDetails = [];
        this.rawProposals = [];
        this.currentPageProposals = {
            numPage: 0,
            proposals: [],
        };
        this.proposal = new Proposal_1.default({
            name: '',
            code_name: '',
            id: 0,
            accepted_at: '',
            contact: {
                name: '',
                email: '',
            },
            status: {
                slug: '',
                name: '',
                phase: '',
            },
            deliverables: [],
        });
    }
    async loadPageForced(n) {
        const clientServerFactor = this.itemsPerPageServer / this.itemsPerPageClient;
        const parseServerPage = Math.ceil(n / clientServerFactor);
        const initialClientPage = (parseServerPage - 1) * clientServerFactor + 1;
        this.rawProposals = await this.fetchProposalsFromServer(parseServerPage, '');
        const newpagedProposal = [];
        if (this.rawProposals) {
            this.rawProposals.forEach((rawP, i) => {
                const myClientPage = initialClientPage + Math.floor(i / this.itemsPerPageClient);
                const ix = Math.floor(i / this.itemsPerPageClient);
                if (newpagedProposal.findIndex((page) => page.numPage === myClientPage) !==
                    -1) {
                    newpagedProposal[ix].proposals.push(rawP);
                }
                else {
                    const propInit = [];
                    propInit.push(rawP);
                    newpagedProposal[ix] = {
                        numPage: myClientPage,
                        proposals: propInit,
                    };
                }
            });
            this.fetchedPagedProposals = [
                ...this.fetchedPagedProposals,
                ...newpagedProposal,
            ];
            this.currentPageProposals = newpagedProposal[n - initialClientPage];
            this.currentPage = n;
        }
    }
    async fetchProposalsFromServer(p, s) {
        const baseURL = '';
        const config = {
            baseURL,
            timeout: 30000,
            headers: {
                'Access-Control-Allow-Origin': '*',
                'Access-Control-Allow-Headers': '*',
            },
        };
        axios_1.default.create(config);
        let proposals = [];
        try {
            // tracking endpoint /tracking/proposals/
            let url = '/data/results/proposals?page=' + p;
            if (s.length > 0) {
                url = '/data/results/proposals?&search=' + s;
            }
            const response = await axios_1.default.get(config.baseURL + url);
            proposals = Object.values(response.data.data);
            this.itemsPerPageServer = response.data.per_page;
            this.totalItems = response.data.total;
        }
        catch (e) {
            console.log(e.message);
        }
        return proposals;
    }
    populateProposals(proposals) {
        this.rawInitialProposals = {
            numPage: 1,
            proposals: proposals
        };
        this.rawProposals = proposals;
        this.filterProposals();
        this.currentPage = 1;
    }
    get currentPageProposalsItems() {
        if (this.paginatedProposals[this.currentPage - 1]) {
            return this.paginatedProposals[this.currentPage - 1].proposals;
        }
        else {
            return [];
        }
    }
    filterProposals() {
        let tempFiltered = this.rawProposals;
        if (this.keyToSearch.length !== 0) {
            tempFiltered = tempFiltered.filter((a) => 
            /*                a.c_muestra_wineseq
                               .toLowerCase()
                               .includes(this.keyToSearch.trim().toLowerCase()) ||
                           a.client_reference
                               .toLowerCase()
                               .includes(this.keyToSearch.trim().toLowerCase()) ||
                           GlobalFilters.formattedDate(a.fecha_muestra)
                               .toLowerCase()
                               .includes(this.keyToSearch.trim().toLowerCase()) ||
                           a.parcel?.user_name
                               .toLowerCase()
                               .includes(this.keyToSearch.trim().toLowerCase()) */
            true);
        }
        this.filteredProposals = tempFiltered;
        this.updateSortableProposals(this.orderCriteria, this.orderDirection);
    }
    get transformOrderCriteria() {
        if (this.orderCriteria === 'id')
            return 'client_reference';
        if (this.orderCriteria === 'parcel')
            return 'parcel';
        if (this.orderCriteria === 'projects/proposal')
            return 'id_proposal';
        if (this.orderCriteria === 'date')
            return 'fecha_muestra';
        return 'client_reference';
    }
    orderProposals() {
        if (this.orderCriteria !== '') {
            /*             this.filteredProposals = this.filteredProposals.sort((a:Proposal, b:Proposal) => {
                            if (this.orderDirection === -1) {
                                return a[this.transformOrderCriteria] > b[this.transformOrderCriteria] ? -1 : 1;
                            } else {
                                return a[this.transformOrderCriteria] < b[this.transformOrderCriteria] ? -1 : 1;
                            }
                        }) */
            this.filteredProposals = this.filteredProposals;
        }
        else {
            this.filteredProposals = this.filteredProposals;
        }
        this.paginateProposals();
    }
    paginateProposals() {
        const numFetchedProposals = this.filteredProposals.length;
        const numPages = Math.ceil(numFetchedProposals / this.itemsPerPageClient);
        const tempPagedProps = Array(numPages).fill('tbd');
        let nextIx = 0;
        const filledPagedProps = tempPagedProps.map((pagRep, i) => {
            const initialIx = nextIx;
            const finalIx = initialIx + this.itemsPerPageClient;
            const newPageProps = {
                numPage: i + 1,
                proposals: this.filteredProposals.slice(initialIx, finalIx)
            };
            nextIx = finalIx;
            return newPageProps;
        });
        this.paginatedProposals = filledPagedProps;
    }
    async loadProposalDetail(id) {
        const myProposal = await this.fetchDetails(id);
        if (myProposal)
            this.proposal = new Proposal_1.default(myProposal);
        const urlParams = new URLSearchParams(window.location.search);
        const crumbParam = urlParams.get('proposal') || '';
        if (crumbParam.length === 0) {
            const url = new URL(window.location.href.split("?")[0]);
            url.searchParams.set('proposal', id.toString());
            window.history.pushState({}, '', url);
        }
    }
    async fetchDetails(id) {
        // Check if already fetched
        const prop = this.fetchedDetails.find((p) => p.id === id);
        if (prop) {
            this.proposal = prop;
        }
        else {
            // Fetch from db 
            // tracking endpoint /tracking
            const baseURL = '/data/results';
            const config = {
                baseURL,
                timeout: 30000,
                headers: {
                    'Access-Control-Allow-Origin': '*',
                    'Access-Control-Allow-Headers': '*',
                },
            };
            axios_1.default.create(config);
            let tempProposal = new Proposal_1.default({});
            try {
                const url = '/proposals/' + id;
                const response = await axios_1.default.get(config.baseURL + url);
                tempProposal = response.data;
                this.proposal = tempProposal;
                this.fetchedDetails.push(response.data);
            }
            catch (e) {
                console.log(e.message);
            }
            return tempProposal;
            // Once fetched -> push it to fetched
            // Oncce fetched -> asign it to proposal
        }
    }
    async loadFilteredProposals(n, s) {
        this.clearAllCachedProposals();
        if (s.length > 0) {
            const clientServerFactor = this.itemsPerPageServer / this.itemsPerPageClient;
            const parseServerPage = Math.ceil(n / clientServerFactor);
            const initialClientPage = (parseServerPage - 1) * clientServerFactor + 1;
            this.rawProposals = await this.fetchProposalsFromServer(1, s);
            const newPagedProposals = [];
            this.rawProposals.forEach((rawP, i) => {
                const myClientPage = initialClientPage + Math.floor(i / this.itemsPerPageClient);
                const ix = Math.floor(i / this.itemsPerPageClient);
                if (newPagedProposals.findIndex((page) => page.numPage === myClientPage) !==
                    -1) {
                    newPagedProposals[ix].proposals.push(rawP);
                }
                else {
                    const propInit = [];
                    propInit.push(rawP);
                    newPagedProposals[ix] = {
                        numPage: myClientPage,
                        proposals: propInit,
                    };
                }
            });
            this.fetchedPagedProposals = [
                ...this.fetchedPagedProposals,
                ...newPagedProposals,
            ];
            this.currentPageProposals = newPagedProposals[n - initialClientPage];
        }
        else {
            await this.loadPageForced(1);
        }
    }
}
exports.default = ProposalsController;
